import { Aditional } from "./aditional";

export class CategoryAditional {

  id: number;
  name: string;
  quantityMax: number;
  quantityMin: number;
  message: string;
  aditionals: Aditional[];
  selected: boolean;

	constructor( c ?: any, a ?: Aditional[]) {
		this.id = c ? c.id : null;
    this.name = c ? c.name : null;
    this.quantityMax = c ? c.quantity_max : null;
    this.quantityMin = c ? c.quantity_min : null;
    this.message = '';
    this.aditionals = a ? a : [];
    this.selected = true;
  }
  
  mapCategory(list: any[]): CategoryAditional[] {
    let newList: CategoryAditional[] = [];
    list.forEach((item: any) => {
      let products: Aditional[] = new Aditional().mapAditional(item.productos);
      let newItem: CategoryAditional = new CategoryAditional(item, products);
      newList.push(newItem);
    });
    return newList;
  }

}
